import {useData} from "vike-react/useData";
import {ApiVideo, ApiVideosData} from "#/src/definitions/ApiDefinitions";
import {VideoCard} from "#/src/components/VideoCard";
import {Sort} from "#/src/utils/sort-utils";
import {DataWrapped} from "#/src/definitions/AppDefinitions";

export function PromotedVideos() {
  const {data: videosData} = useData() as DataWrapped<ApiVideosData>;

  const promotedVideos = Sort.byDate(videosData.promotedVideos);
  return <section className="special-article special-gnt-secondary my-8">
    <div className="container-xxl">
      <div className="row">
        <div className="col-xl-12">
          <div className="title-between">
            <h2 className="basic-headline">
              Sekcja promowana
            </h2>
          </div>
        </div>
      </div>
      <div className="row mt-7">
        {promotedVideos.map((video: ApiVideo) => <div key={video.id} className="col-xl-4 col-sm-6 col-md-4"><VideoCard isAd video={video} lazy/></div>)}
      </div>
    </div>
  </section>
}